var image_viewer_default = {
  "fontElementMap": "BM5Kb",
  "imageContainer": "b-9kj",
  "expandButton": "Zre2b",
  "expandIcon": "pb0li",
  "pointer": "_7c-9w",
  "imageWrapper": "dGGL5",
  "imageRatio": "FmNhw",
  "image": "HSVa2",
  "imageOverlay": "Pa7ym",
  "imagePreload": "-oOap",
  "imageHighres": "dcxOo",
  "onlyHighRes": "zD7m0",
  "image_loading": "E8QQq"
};
export {
  image_viewer_default as default
};
//# sourceMappingURL=image-viewer-scss.js.map
